import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { IReduxAppState } from "../../../reducers";
import QrDownloader from "./QrDownloader";
import smallIconEN from "../../../assets/images/qr-template-small-icon-en.png";
import largeIconEN from "../../../assets/images/qr-template-large-icon-en.png";
import smallIconES from "../../../assets/images/qr-template-small-icon-es.png";
import largeIconES from "../../../assets/images/qr-template-large-icon-es.png";
import plainIcon from "../../../assets/images/qr-template-plain-icon.png";
import squarePlaceholder from "../../../assets/images/qr-code-placeholder-square.png";
import rectanglePlaceholder from "../../../assets/images/qr-code-placeholder-rectangle.png";
import QrMaterials from "./QrMaterials";
import { Grid } from "@material-ui/core";

interface Template {
  small: any;
  large: any;
}

const TEMPLATES: {
  [key: string]: Template;
} = {
  en: {
    small: smallIconEN,
    large: largeIconEN,
  },
  es: {
    small: smallIconES,
    large: largeIconES,
  },
};

export function DownloadQRCodePage(): JSX.Element {
  const { t } = useTranslation();

  const seletectedVenueId = useSelector(
    (state: IReduxAppState) => state.selectedVenueId
  )!;

  const venue = useSelector(
    (state: IReduxAppState) => state.venue[seletectedVenueId].venueData!
  );

  const currency = useSelector(
    (state: IReduxAppState) => state.localization.currency
  );

  const currencies = useSelector(
    (state: IReduxAppState) => state.localization.currencies
  );

  const currentLanguage = useSelector(
    (state: IReduxAppState) => state.language.current
  ) as string;

  const [languageExtension, setLanguageExtension] = useState('en');

  useEffect(() => {
    setLanguageExtension(currentLanguage.split("-")[0]);
  }, [currentLanguage]);

  const isGBP =
    currencies.filter((curr: any) => curr.id === currency)[0].iso_code ===
    "GBP";

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      wrap="nowrap"
      style={{ padding: "2rem" }}
    >
      {isGBP && <QrMaterials />}

      <QrDownloader
        id="square-logo"
        venue={venue}
        template={TEMPLATES[languageExtension]?.small ?? smallIconEN}
        placeholder={squarePlaceholder}
        title={t("qrCode.squareLogo")}
        hasUploader={true}
        aspect={[1, 1]}
        yoelloLogoSize={140}
        yoelloLogoPosition={{ x: 1503, y: 223 }}
        qrSize={505}
        qrPosition={{ x: 1320, y: 40 }}
        logoSize={{ w: 210, h: 210 }}
        logoPosition={{ x: 510, y: 60 }}
        plaqueSize={{ w: 1876, h: 585 }}
        textPosition={{ x: 90, y: 520 }}
        textFont="50px Arial"
        stretch={true}
      />

      <QrDownloader
        id="large-logo"
        venue={venue}
        template={TEMPLATES[languageExtension]?.large ?? largeIconEN}
        placeholder={rectanglePlaceholder}
        title={t("qrCode.largeLogo")}
        hasUploader={true}
        aspect={[3, 1]}
        yoelloLogoSize={140}
        yoelloLogoPosition={{ x: 1503, y: 223 }}
        qrSize={505}
        qrPosition={{ x: 1320, y: 40 }}
        logoSize={{ w: 630, h: 210 }}
        logoPosition={{ x: 90, y: 60 }}
        plaqueSize={{ w: 1876, h: 585 }}
        textPosition={{ x: 90, y: 520 }}
        textFont="50px Arial"
        stretch={true}
      />

      <QrDownloader
        id="plain-square"
        venue={venue}
        template={plainIcon}
        title={t("qrCode.plainQrCode")}
        hasUploader={false}
        yoelloLogoSize={50}
        yoelloLogoPosition={{ x: 65, y: 65 }}
        qrSize={180}
        qrPosition={{ x: 0, y: 0 }}
        plaqueSize={{ w: 180, h: 180 }}
        stretch={false}
      />
    </Grid>
  );
}
